module.exports = __webpack_public_path__ + "static/media/9.8262bc6e.png";